import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { SPINNER_SIZE, SPINNER_COLOR } from '../constants/constant'
import {
  getLoadingSpinnerIndicatorSx,
  getLoadingSpinnerTextSx,
  loadingSpinnerRootSx
} from '../constants/loadingSpinnerSx'

const LoadingSpinner = ({
  text = 'Cargando...',
  size = SPINNER_SIZE,
  color = SPINNER_COLOR,
  role = 'status'
}) => {
  return (
    <Box
      component="span"
      role={role || undefined}
      aria-live={role ? 'polite' : undefined}
      sx={loadingSpinnerRootSx}
    >
      <Box component="span" sx={getLoadingSpinnerIndicatorSx(size, color)} aria-hidden />
      {text ? (
        <Typography component="span" variant="body1" sx={getLoadingSpinnerTextSx(color)}>
          {text}
        </Typography>
      ) : null}
    </Box>
  )
}

export default LoadingSpinner
